import { postStateChange } from "@cirrus-delivery/v1/_redux/exam/proctorio/utils"

export const startProctorioSession = () => {
  postStateChange("start")
}
